import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * The iOS and Android apps (ADR 0075) run this same client, bundled, in a
 * Capacitor web view. What differs is decided here and nowhere else: the
 * stores forbid selling digital goods outside their own billing, and Google
 * refuses its sign-in inside an embedded web view.
 */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * The shell's own wiring, inert in a browser: Android's back button closes
 * the topmost window the way Escape does instead of leaving the game. The
 * system bars are hidden natively (Info.plist, MainActivity).
 */
export function installNativeShell(): void {
  if (!isNativeApp()) return;
  document.documentElement.classList.add('native-app');
  void App.addListener('backButton', () => {
    window.dispatchEvent(
      new KeyboardEvent('keydown', { key: 'Escape', code: 'Escape', bubbles: true }),
    );
  });
}
